var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Download_Data"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download_Data",
    clipPath: "url(#clip-Download_Data)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Fx_18_Download_Data",
    "data-name": "Icons_Fx_18_Download Data",
    transform: "translate(-1.2 -1.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black_Circle",
    transform: "translate(1.2 1.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 300,
    cy: 300,
    r: 300,
    fill: "#4c4c4c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(17.5 9.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4_00000065792907848029724530000002947089093144205448_",
    transform: "translate(190 117.215)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    y2: 280.851,
    transform: "translate(92.385)",
    fill: "none",
    stroke: "#f6f6f6",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 35
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y1: 130.011,
    x2: 89.362,
    transform: "translate(94.737 150.84)",
    fill: "none",
    stroke: "#f6f6f6",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 35
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x1: 89.026,
    y1: 130.011,
    transform: "translate(0 150.84)",
    fill: "none",
    stroke: "#f6f6f6",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 35
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x2: 240,
    transform: "translate(162.5 463.448)",
    fill: "none",
    stroke: "#f6f6f6",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 35
  })))));
};
export default __webpack_public_path__ + "static/media/Download_Data.a8d90ecd.svg";
export { SvgComponent as ReactComponent };